interface DateRangeBase {
  startDate: Date;
  endDate: Date;
  timeframe: string;
  totalDays: number;
}

interface CallStatisticsViewedEvent extends DateRangeBase {
  locationIds: number[];
}

interface CallHistoryViewedEvent extends DateRangeBase {
  locationIds: number[];
  filters: string[];
  offset: number;
}

export const identifyUser = (userId: string, email: string) => {
  window.analytics.identify(userId, {
    email: email,
  });
};

export const trackCallStatisticsViewed = (event: CallStatisticsViewedEvent): void => {
  window.analytics.track('Call Statistics Viewed', event);
};

export const trackCallStatisticsGraphFilterChanged = (newFilter: string): void => {
  window.analytics.track('Call Statistics Graph Filter Changed', {
    filter: newFilter,
  });
};

export const trackCallStatisticsExplanationViewed = (itemName: string): void => {
  window.analytics.track('Call Statistics Explanation Viewed', {
    item: itemName,
  });
};

export const trackCallHistoryViewed = (event: CallHistoryViewedEvent): void => {
  window.analytics.track('Call History Viewed', event);
};
